var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-create main-content" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("pos.discrepancy_report"))),
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _vm.userType == "super_admin"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/super-admin/dashboard",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "supplier"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/supplier/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "anchor"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/anchor/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "funder"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/funder/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _vm.userType == "super_admin"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/super-admin/purchase-orders",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("pos.po", 2)))]
                  )
                : _vm.userType == "supplier"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/supplier/purchase-orders",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("pos.po", 2)))]
                  )
                : _vm.userType == "anchor"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/anchor/purchase-orders",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("pos.po", 2)))]
                  )
                : _vm.userType == "funder"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/funder/purchase-orders",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("pos.po", 2)))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                { attrs: { slot: "item-title", to: "#" }, slot: "item-title" },
                [_vm._v(_vm._s(_vm.$tc("pos.discrepancy_report")))]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.discrepency_report.length > 0
          ? _c("div", { staticClass: "page-actions row" }, [
              _c(
                "div",
                { staticClass: "col-xs-2 mr-4" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: {
                        size: "large",
                        icon: "arrow-down",
                        color: "theme",
                      },
                      on: { click: _vm.download_excel },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("data_exports.download_excel")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("SinglePORow", {
        attrs: { fetchData: _vm.fetchData, tableDivId: _vm.tableDivId },
      }),
      _vm._v(" "),
      _c(
        "table-component",
        {
          ref: "table",
          attrs: {
            "show-filter": false,
            data: _vm.discrepency_report,
            "table-class": "table",
          },
        },
        [
          _c("table-column", {
            attrs: {
              label: _vm.$t("pos.item.title"),
              "sort-as": "name",
              show: "name",
            },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("pos.item.part_number"),
              "sort-as": "part_number",
              show: "part_number",
            },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("pos.item.reason") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    row.reason === "price_difference"
                      ? _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("pos.item.price_difference", {
                                actual_price: _vm.$utils.formatGraphMoney(
                                  row.actual_price,
                                  _vm.currency
                                ),
                                requested_price: _vm.$utils.formatGraphMoney(
                                  row.requested_price,
                                  _vm.currency
                                ),
                              })
                            ),
                          },
                        })
                      : row.reason === "item_not_found"
                      ? _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("pos.item.item_not_found")
                            ),
                          },
                        })
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }